import type { CSSProperties, ReactNode } from "react";
import { cx } from "./fieldContext";

export interface DividerProps {
  type?: "horizontal" | "vertical";
  orientation?: "horizontal" | "vertical" | "left" | "right" | "center" | "start" | "end";
  titlePlacement?: "left" | "right" | "center" | "start" | "end";
  dashed?: boolean;
  plain?: boolean;
  size?: "small" | "middle" | "large";
  className?: string;
  style?: CSSProperties;
  children?: ReactNode;
}

/** Trennlinie des Kits (Ersatz für Antd `Divider`), optional mit Beschriftung. */
export function Divider({ type, orientation, titlePlacement, dashed, plain, size, className, style, children }: DividerProps) {
  const vertical = type === "vertical" || orientation === "vertical";
  if (vertical) return <span role="separator" aria-orientation="vertical" className={cx("ck-divider ck-divider--vertical", className)} style={style} />;
  const placementSource = titlePlacement ?? (orientation && orientation !== "horizontal" ? orientation : undefined) ?? "center";
  const placement = placementSource === "left" ? "start" : placementSource === "right" ? "end" : placementSource;
  return (
    <div
      role="separator"
      className={cx("ck-divider", dashed && "ck-divider--dashed", plain && "ck-divider--plain", size && `ck-divider--${size}`, children != null && `ck-divider--text ck-divider--${placement}`, className)}
      style={style}
    >
      {children != null ? <span className="ck-divider-text">{children}</span> : null}
    </div>
  );
}
